import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import UserRole from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/UserRole";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";

class LazoRoleService {
  path: string;
  constructor(path: string) {
    this.path = path;
  }

  getAllCompanyRoles(): Promise<ApiResponseV2<UserRole[]>> {
    return HttpClientV2.get(`${this.path}/company`);
  }

  getAllRolesForUserWithinCompany(tenantExternalId: string, userExternalId: string): Promise<ApiResponseV2<UserRole[]>> {
    return HttpClientV2.get(`${this.path}/${tenantExternalId}/${userExternalId}`);
  }

  getAllRolesForLazoUserWithinCompany(tenantExternalId: string, userExternalId: string): Promise<ApiResponseV2<UserRole[]>> {
    return HttpClientV2.get(`${this.path}/${tenantExternalId}/lazo-user/${userExternalId}`);
  }

  getAllPortalRoles(): Promise<ApiResponseV2<UserRole[]>> {
    return HttpClientV2.get(`${this.path}/portal`);
  }
}

export default new LazoRoleService("/api/lazo-roles");
